import React from 'react'
import { ViewIcon } from "@chakra-ui/icons";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  IconButton,
  Text,
  Image,
  Box,
  Divider,
  Avatar
} from "@chakra-ui/react";
import { ChatState } from '../../context/chatProvider';
import PersonIcon from './PersonIcon';

const ProfileModal = ({user,children}) => {
  // const {user} = ChatState()
    const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      {
          children
          ? (<span onClick ={onOpen}>{children}</span>) 
          :(<IconButton  display={{ base: "flex" }}
          //  icon={<ViewIcon />} 
          // fontSize='10px'
   
           icon={<PersonIcon />}
           onClick={onOpen} 
            border={'1px solid #868686'}
            color={'#868686'}
              variant="ghost" 
             borderRadius={'10px 0px 10px 0px'}
              borderBottom={'none'}
              borderLeft={'none'}
           />)
      }
      <Modal size="md" onClose={onClose} isOpen={isOpen} isCentered>
        <ModalOverlay />
        <ModalContent h="410px"  
        backgroundImage={"url('./assets/BodyBG.png')"}
        borderRadius={"10px 10px 10px 10px"}
        backgroundSize={"cover"}
        boxShadow={"bxshd.inset_blk"}

        >
          {/* <Box display="flex" alignItems="center" justifyContent="center" h="100%" > */}
         
          <ModalHeader
            fontSize="40px"
            fontFamily="Gilroy"
            display="flex"
            justifyContent="center"
             bg={'white'}
            borderRadius={"10px 10px 0 0"}
            background={"url('./assets/BodyBG2.png')"}
            backgroundSize={'cover'}
            boxShadow={'bxshd.inset_blk'}
            color={"#868686"}
            
          >
            {user.preferredName}
          </ModalHeader>
          {/* </Box> */}
          <ModalCloseButton />
          <ModalBody
            display="flex"
            flexDir="column"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box
        display="flex"
        flexDir="row"
        p={3}
        // bg="rgba(250,250,250,0.2)"  
        bg="rgba(250,250,250,0.9)"  
        backgroundImage={"url('./assets/BodyBG2.png')"}
        // bg="#F8F8F8"  
        w="100%"
        h="100%"
        borderRadius="10px 0 10px 10px"
        overflowX="hidden"
        overflowY="scroll"
        // backgroundImage={"url('./assets/BodyBG.png')"}
        // backgroundColor={"bgs.accntBx"}
        boxShadow={"bxshd.inset_blk"}
         backdropFilter={"blur(2px)"} 
         justifyContent={'space-evenly'}
         textAlign={'center'}
      >

            {/* <Image
              // borderRadius="full"
              borderRadius="100%"
              boxSize="120px"
              w={'100px'}
              h={'auto'}
              src={user.pic}
              alt={user.preferredName}
              border={user.isOnline?'3px solid limegreen':'2px solid orange'}
               boxShadow={'0px 0px 5px 5px rgba(175, 175,175, 0.5)'}
              alignSelf={ 'center'}
            /> */}

            <Avatar
              // borderRadius="full"
              // borderRadius="100%"
              // boxSize="120px"
              p={2}
              w={'100px'}
              h={'auto'}
              src={user.pic}
              alt={user.preferredName}
              border={user.isOnline?'3px solid limegreen':'2px solid orange'}
               boxShadow={'0px 0px 5px 5px rgba(175, 175,175, 0.5)'}
              alignSelf={ 'center'}
            />
            <Divider orientation='vertical'/>
            <Text
              color={'#868686'}
              fontSize={{ base: "18px", md: "18px" }}
              fontFamily="Gilroy"
            >
             <strong> Email:</strong> {user.email}
             <br></br>
             <Text color= {user.isOnline? 'limegreen':'orange'}>
               {user.isOnline? 'online': 'offline'}
               </Text>
              {/* border={user.isOnline?'3px solid limegreen':'2px solid orange'} */}
            </Text>
            </Box>
          </ModalBody>
          <ModalFooter>
           <Button border={"1px solid #868686"} borderRadius="10px 0px 10px 0px" onClick={onClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ProfileModal